const InfoItem = ({ label, value }: { label: string; value: string }) => (
  <div>
    <p className="text-xs text-pColor mb-1">{label}</p>
    <p className="font-semibold truncate">{value}</p>
  </div>
);

export default InfoItem;
